var consoleHome = [
    {
        name: 'home',
        path: 'home',
        component: function () { return import('../../views/home/console-home.vue'); },
    },
    {
        name: 'messageList',
        path: 'message',
        component: function () { return import('../../components/console-home/message-list.vue'); },
        children: [
            {
                name: 'messageListTable',
                path: 'message-list-table',
                component: function () { return import('../../components/console-home/message-list-table.vue'); },
            },
        ],
    },
];
export default consoleHome;
